import React from 'react'

// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';

// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import BreadCrumbs from 'src/components/custom-breadcrumbs/breadcrumbs';


import CandidateNewEditForm from '../candidate-new-edit-form';

export default function CandidateCreateView() {
    const settings = useSettingsContext();
  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      {/* <CustomBreadcrumbs
        heading="Create New Candidate"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'Candidate',
            href: paths.dashboard.recruitment.root,
          },
          { name: 'New user' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      /> */}
      <BreadCrumbs heading='New Candidate' />

      <CandidateNewEditForm />
    </Container>
  )
}
